import { ISurveyDetailsDto } from "../../app/models/survey";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";

// reactstrap components
import {
  Button,
  UncontrolledTooltip,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import SurveyResponseEditModal from "./SurveyResponseEditModal";
import GenericConfirmModal from "../common/GenericConfirmModal";
import classnames from "classnames";
import Loader from "../common/Loader";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface SurveyParams {
  survey: ISurveyDetailsDto;
  languages: Number[];
}

const SurveyResponsesComponent: React.FC<SurveyParams> = ({
  survey,
  languages,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, selectedLanguageId, allLanguages } = rootStore.commonStore;

  const { LoadSurveyResponses, surveysResponses, deleteSurveyResponse } =
    rootStore.surveyStore;

  const [activeTab, setActiveTab] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingResponseId, setEditingResponseId] = useState(0);
  const [t] = useTranslation(["surveys"], translationHookOptions);

  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const editResponse = (responseId: number) => {
    setEditingResponseId(responseId);
    setIsModalOpen(true);
  };

  const deleteResponse = (responseId: number) => {
    setEditingResponseId(responseId);
    setIsDeleteModalOpen(true);
  };

  useEffect(() => {
    LoadSurveyResponses(
      survey.meetingDetails.id,
      survey.survey.surveyQuestionId
      // selectedLanguageId
    )
      .then((dto) => {
        if (dto.surveyResponses.length > 0)
          setActiveTab(dto.surveyResponses[0].languageId.toString());
      })
      .catch();

    return () => {};
  }, [
    LoadSurveyResponses,
    survey.meetingDetails.id,
    survey.survey.surveyQuestionId,
    selectedLanguageId,
  ]);

  // const editFormatter = (cell: any, row: any) => {
  //   return (
  //     <>
  //       <Button
  //         id={`btnEdit_${row.id}`}
  //         color="link"
  //         onClick={() => editResponse(row.id)}
  //         disabled={!survey.survey.canEdit}
  //       >
  //         <i className="fas fa-edit fa-lg text-default"></i>
  //       </Button>
  //       <UncontrolledTooltip
  //         delay={0}
  //         placement="top"
  //         target={`btnEdit_${row.id}`}
  //       >
  //         {t("survey_operation_edit")}
  //       </UncontrolledTooltip>

  //       <Button
  //         id={`btndelete_${row.id}`}
  //         color="link"
  //         onClick={() => deleteResponse(row.id)}
  //         disabled={!survey.survey.canEdit}
  //       >
  //         <i className="fas fa-trash fa-lg text-danger"></i>
  //       </Button>
  //       <UncontrolledTooltip
  //         delay={0}
  //         placement="top"
  //         target={`btnEdit_${row.id}`}
  //       >
  //         {t("survey_operation_edit")}
  //       </UncontrolledTooltip>
  //     </>
  //   );
  // };

  // const styleProperty: React.CSSProperties = {
  //   fontWeight: 600,
  //   padding: 0,
  // };

  if (!surveysResponses) return <Loader></Loader>;

  return (
    <>
      {" "}
      <Row className="mt-3">
        <Col sm={12}>
          {survey.survey.canEdit && (
            <Button
              className={classNames(
                "addButton surveyButton",
                `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
              )}
              onClick={() => editResponse(0)}
            >
              <span className="btn-inner--icon mb-0 pb-0">
                <i className="fas fa-plus" />
              </span>
              <span className="verticalText addResponse">
                {" "}
                {t("answers_component_add")}
              </span>
            </Button>
          )}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={10}>
          {surveysResponses && surveysResponses.countResponses > 0 && (
            <>
              <div className="modalLabel">{t("answers_component_answers_label")}</div>
              <Nav tabs className="navQuestion">
                {surveysResponses &&
                  surveysResponses.surveyResponses.map((l) => (
                    <NavItem key={l.languageId}>
                      <NavLink
                        href="#"
                        className={classnames("surveyNavLinkResponse", {
                          active: activeTab === l.languageId.toString(),
                        })}
                        onClick={() => {
                          toggle(l.languageId.toString());
                        }}
                      >
                        <span
                          className={classnames(
                            "mr-1 flag-icon fa-2x",
                            allLanguages.filter((x) => x.id === l.languageId)[0]
                              .flagIcon
                          )}
                        ></span>
                      </NavLink>
                    </NavItem>
                  ))}
              </Nav>

              <TabContent activeTab={activeTab} className="pt-0 tabQuestion">
                {surveysResponses &&
                  surveysResponses.surveyResponses.map((l, indexl) => (
                    <TabPane
                      key={`${indexl}${l.languageId.toString()}`}
                      tabId={l.languageId.toString()}
                      className="tabPaneSurvey"
                    >
                      {l.responseLanguage.map((r, indexr) => (
                        <Row className="questionRow">
                          <Col lg={10} sm={9} className="questionCol">
                            <textarea
                              key={`${indexl}_${indexr}`}
                              value={r.response}
                              disabled
                              className="w-100"
                            ></textarea>
                          </Col>
                          <Col lg={2} sm={3} className="questionCol">
                            <Button
                              id={`btnEdit_${indexl}${indexr}${r.index}`}
                              color="link"
                              onClick={() => editResponse(r.id)}
                            >
                              <i className="fad fa-edit fa-lg text-default"></i>
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              placement="top"
                              target={`btnEdit_${indexl}${indexr}${r.index}`}
                            >
                              {t("survey_operation_edit")}
                            </UncontrolledTooltip>

                            <Button
                              id={`btndelete_${indexl}${indexr}${r.index}`}
                              color="link"
                              onClick={() => deleteResponse(r.id)}
                              // disabled={!survey.canEdit}
                            >
                              <i className="fad fa-trash fa-lg text-danger"></i>
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              placement="top"
                              target={`btndelete_${indexl}${indexr}${r.index}`}
                            >
                              {t("survey_operation_delete")}
                            </UncontrolledTooltip>
                          </Col>
                        </Row>
                      ))}
                      <Row></Row>
                    </TabPane>
                  ))}
              </TabContent>
            </>
          )}
        </Col>
      </Row>
      <SurveyResponseEditModal
        languages={languages}
        surveyResponseId={editingResponseId}
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        survey={survey.survey}
        onSubmit={() => {
          LoadSurveyResponses(
            survey.meetingDetails.id,
            survey.survey.surveyQuestionId,
            selectedLanguageId
          )
            .then(() => setIsModalOpen(!isModalOpen))
            .catch();
        }}
      ></SurveyResponseEditModal>
      <GenericConfirmModal
        title={t("answers_component_delete_modal_title")}
        messages={t("answers_component_delete_modal_message")}
        isOpen={isDeleteModalOpen}
        toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
        action={() => {
          if (editingResponseId) {
            deleteSurveyResponse(editingResponseId).then(() => {
              LoadSurveyResponses(
                survey.meetingDetails.id,
                survey.survey.surveyQuestionId,
                selectedLanguageId
              )
                .then()
                .catch();
            });
          }
        }}
      />
    </>
  );
};

export default observer(SurveyResponsesComponent);
